/* ST 2026-10-11 (Wrike 4582125059): (i) info panel of the "Beliebtes Zubehör" cards (snippets/st-bundle-info.liquid).
   Opening/closing, overlay, scroll lock, focus, Escape and swipe are the theme's <drawer-element>; the image slider is the
   theme's slider-element + slider-dots + previous/next buttons; focus on the X after opening is assets/st-pdp-info.js.
   This file only keeps a size-picker card (unpinned lists) and its panel in sync: the gallery and bullets of the selected
   size, the card's current price and the card's hover image. Pinned cards have one fixed variant and need nothing here.
   Rollback: delete this asset and its <script> tag in sections/main-product.liquid (product_bundle). */
(function () {
  if (window.stBundleInfoReady) return;
  window.stBundleInfoReady = true;

  // Runs after the drawer's own click handler on the button (bubbling), i.e. while the panel opens.
  document.addEventListener("click", function (event) {
    var button =
      event.target && event.target.closest
        ? event.target.closest(".st-bundle-card__info")
        : null;
    if (!button) return;

    var card = button.closest(".st-bundle-card");
    var select = card && card.querySelector("select");
    var panel = document.getElementById(button.getAttribute("aria-controls"));
    if (!select || !panel) return;

    // Gallery and bullets of the selected size (round 3).
    var lists = panel.querySelectorAll("[data-binfo-variant]");
    lists.forEach(function (list) {
      list.hidden = list.getAttribute("data-binfo-variant") !== select.value;
    });

    var cardPrice = card.querySelector(".st-bundle-card__prices");
    var panelPrice = panel.querySelector("[data-binfo-price]");
    if (
      cardPrice &&
      panelPrice &&
      panel.getAttribute("data-variant-id") !== select.value
    ) {
      var copy = cardPrice.cloneNode(true);
      copy.classList.remove("st-bundle-card__prices");
      copy.classList.add("st-binfo__prices");
      panelPrice.replaceChildren(copy);
      panel.setAttribute("data-variant-id", select.value);
    }

    // "Preis im Set" only for a size with a bundle price (same rule as the card's "Im Set" pill).
    var setNote = panel.querySelector("[data-binfo-set]");
    var option = select.selectedOptions && select.selectedOptions[0];
    if (setNote && option)
      setNote.hidden = !option.hasAttribute("data-bundle-max");
  });

  // Round 3 (Ali, 11.10.): a size-picker card's hover image follows the selected size (option data-hover-src, see
  // main-product). theme.js ProductBundlePicker already swaps the card image; a size without its own 2nd image gets no hover.
  document.addEventListener("change", function (event) {
    var select = event.target;
    if (!select || select.tagName !== "SELECT") return;
    var card = select.closest(".st-bundle-card");
    var media = card && card.querySelector(".st-bundle-card__media");
    var option = select.selectedOptions && select.selectedOptions[0];
    if (!media || !option) return;

    var hover = media.querySelector(".st-bundle-card__image--hover");
    var src = option.getAttribute("data-hover-src");
    if (!src) {
      media.classList.remove("st-bundle-card__media--hover");
      if (hover) hover.remove();
      return;
    }
    if (!hover) {
      var image = media.querySelector(".st-bundle-card__image");
      if (!image) return;
      hover = image.cloneNode(false);
      hover.classList.add("st-bundle-card__image--hover");
      hover.alt = "";
      media.appendChild(hover);
    }
    hover.srcset = option.getAttribute("data-hover-srcset") || "";
    hover.src = src;
    media.classList.add("st-bundle-card__media--hover");
  });
})();
